import type { HtmlHTMLAttributes } from "react";
import type React from "react";

export default function BaseTable({
  children,
  props,
}: {
  children: React.ReactNode;
  props?: HtmlHTMLAttributes<HTMLDivElement>;
}) {
  return (
    <div
      {...props}
      className={`${props?.className} border border-grayscale-100 rounded-xl overflow-hidden`}
    >
      {children}
    </div>
  );
}
